export const formatAxleWeightsFromFormData = (formData, numberOfAxles, oldAxleWeights = []) => {
  const newAxleWeights = []
  let aggregateGross = 0
  let aggregateTare = 0
  let aggregateIsManualGross = false
  let aggregateIsManualTare = false

  for (let i = 1; i <= numberOfAxles; i++) {
    const oldAxleData = oldAxleWeights?.find(axleData => axleData.axleNumber === i)
    const newAxleData = {
      axleNumber: i,
      gross: formData.axles?.[`axle-${i}`]?.gross || 0,
      tare: formData.axles?.[`axle-${i}`]?.tare || 0,
      grossImages: formData.axles?.[`axle-${i}`]?.grossImages || [],
      tareImages: formData.axles?.[`axle-${i}`]?.tareImages || [],
      isManualGross: formData.axles?.[`axle-${i}`]?.isManualGross || false,
      isManualTare: formData.axles?.[`axle-${i}`]?.isManualTare || false,
    }
    aggregateGross += Number(newAxleData.gross)
    aggregateTare += Number(newAxleData.tare)
    if (!aggregateIsManualGross && newAxleData.isManualGross) {
      aggregateIsManualGross = true
    }
    if (!aggregateIsManualTare && newAxleData.isManualTare) {
      aggregateIsManualTare = true
    }
    if (oldAxleData) {
      newAxleData.id = oldAxleData.id
    }
    newAxleWeights.push(newAxleData)
  }
  return {
    axleWeights: newAxleWeights,
    aggregateGross,
    aggregateTare,
    aggregateIsManualGross,
    aggregateIsManualTare,
  }
}
